/* eslint-disable tailwindcss/no-arbitrary-value */
import { cn } from '@ui/lib';
import {
  Body1,
  Display3,
  StyledText,
  Title2,
} from '../../tokens/typography/StyledText';

export interface ScreenTitleProps {
  screenTitle: string;
  subTitle?: string;
  showPadding?: boolean;
  className?: string;
}

export const ScreenTitle = ({
  screenTitle,
  subTitle,
  showPadding,
  className,
}: ScreenTitleProps) => {
  return (
    <div
      data-testid="screen-title"
      className={cn(
        'inline-flex h-fit w-full flex-col items-start justify-center gap-sm',
        {
          'px-md': showPadding,
          'px-none': !showPadding,
        },
        className,
      )}
    >
      <div className="inline-flex h-fit w-full flex-col items-stretch justify-start gap-y-sm self-stretch">
        <Title2>{screenTitle}</Title2>
        {subTitle && <Body1>{subTitle}</Body1>}
      </div>
    </div>
  );
};
